export const LETTER_WIDTH_IN = 8.5;
export const LETTER_HEIGHT_IN = 11;
export const CSS_DPI = 96;
export const LETTER_WIDTH_PX = Math.round(LETTER_WIDTH_IN * CSS_DPI); // 816px
export const LETTER_HEIGHT_PX = Math.round(LETTER_HEIGHT_IN * CSS_DPI); // 1056px
export const LETTER_WIDTH_POINTS = 612;
export const LETTER_HEIGHT_POINTS = 792;

/**
 * Page size presets. Dimensions in inches, converted to pixels at 96 DPI for screen.
 */
export const PAGE_SIZE_PRESETS = [
  {
    key: "letter",
    label: "US Letter (8.5 × 11\")",
    widthIn: 8.5,
    heightIn: 11,
  },
  {
    key: "us_comic",
    label: "US Comic (6.625 × 10.25\")",
    widthIn: 6.625,
    heightIn: 10.25,
  },
  {
    key: "manga_b6",
    label: "Manga B6 (5 × 7.5\")",
    widthIn: 5,
    heightIn: 7.5,
  },
  {
    key: "a4",
    label: "European A4 (8.27 × 11.69\")",
    widthIn: 8.27,
    heightIn: 11.69,
  },
  {
    key: "webcomic",
    label: "Webcomic (800px wide)",
    widthPx: 800,
    heightPx: 1200,
  },
  // Landscape and screen sizes for storyboards
  {
    key: "letter_landscape",
    label: "US Letter landscape (11 × 8.5\")",
    widthIn: 11,
    heightIn: 8.5,
  },
  {
    key: "a4_landscape",
    label: "A4 landscape (11.69 × 8.27\")",
    widthIn: 11.69,
    heightIn: 8.27,
  },
  {
    key: "tabloid_landscape",
    label: "Tabloid landscape (17 × 11\")",
    widthIn: 17,
    heightIn: 11,
  },
  {
    key: "screen_16_9",
    label: "Screen 16:9 (1920 × 1080 px)",
    widthPx: 1920,
    heightPx: 1080,
  },
  {
    key: "custom",
    label: "Custom…",
    widthIn: 8.5,
    heightIn: 11,
  },
];

export const pageSizeToPx = (preset) => {
  if (preset.widthPx && preset.heightPx) {
    return { width: preset.widthPx, height: preset.heightPx };
  }
  return {
    width: Math.round(preset.widthIn * CSS_DPI),
    height: Math.round(preset.heightIn * CSS_DPI),
  };
};

export const pageSizeToPoints = (preset) => {
  if (preset.widthPx && preset.heightPx) {
    // Convert pixels to points (72 points per inch, 96 px per inch)
    return {
      width: Math.round((preset.widthPx / CSS_DPI) * 72),
      height: Math.round((preset.heightPx / CSS_DPI) * 72),
    };
  }
  return {
    width: Math.round(preset.widthIn * 72),
    height: Math.round(preset.heightIn * 72),
  };
};

export const findPageSizePreset = (key) =>
  PAGE_SIZE_PRESETS.find((p) => p.key === key) || PAGE_SIZE_PRESETS[0];

export const normalizePortraitDimensions = (pageWidth, pageHeight) => {
  const fallback = { width: LETTER_WIDTH_PX, height: LETTER_HEIGHT_PX };

  if (!pageWidth || !pageHeight) {
    return fallback;
  }

  // If reasonable pixel dimensions, use them directly
  if (pageWidth > 100 && pageHeight > 100) {
    return {
      width: Math.round(pageWidth),
      height: Math.round(pageHeight),
    };
  }

  // If looks like inches, convert
  if (pageWidth < 50 && pageHeight < 50) {
    return {
      width: Math.round(pageWidth * CSS_DPI),
      height: Math.round(pageHeight * CSS_DPI),
    };
  }

  return fallback;
};
